import {
  Component,
  EventEmitter,
  Input,
  Output,
  TemplateRef,
} from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import {
  BestScores,
  CasualTournamentDetails,
  CurrentUser,
  EventSchedule,
} from '@fantaz/shared/data-access/models';
import { TournamentsUiScoreSummaryModule } from '@fantaz/tournaments/ui/score-summary';

@Component({
  selector: 'fz-tab-rules',
  standalone: true,
  imports: [MatCardModule, MatIconModule, TournamentsUiScoreSummaryModule],
  templateUrl: './tournament-rules.html',
  styleUrls: ['./tournament-rules.scss'],
})
export class TournamentRules {
  @Input() tournamentRules: string | undefined;
  @Input() prizeImage: string | undefined;
  @Input() user: CurrentUser | null | undefined;
  @Input() eventCode?: string;
  @Input() bestScores?: BestScores | undefined;
  @Input() eventScheduleDetails: EventSchedule | null | undefined;
  @Input() isLEP: boolean | undefined;
  @Input() eventPrototypeUuid: string | undefined;
  @Input() casualGameStartTime: string | undefined;
  @Input() casualGameEndTime: string | undefined;
  @Input() retired: boolean | undefined;
  @Input() entryAmount: number | undefined;
  @Input() details?: CasualTournamentDetails | null | undefined;
  @Input() playControls: TemplateRef<any>;

  @Output() share: EventEmitter<void> = new EventEmitter();
  @Output() playGame: EventEmitter<void> = new EventEmitter();
  @Output() tryForFree: EventEmitter<void> = new EventEmitter();

  onShare() {
    this.share.emit();
  }

  onPlay() {
    this.playGame.emit();
  }

  onTryForFree() {
    this.tryForFree.emit();
  }

  inTheFuture() {
    if (this.casualGameStartTime) {
      return (
        new Date(this.casualGameStartTime).getTime() > new Date().getTime()
      );
    }
    return false;
  }
}
